export const CSV_OBJECT_BASE_NAME = '__giraffe_csv_object'
export const CSV_OBJECT_START_STRING = ',&quot;{'
export const CSV_OBJECT_END_STRING = '}&quot;,'
